import React from 'react';
import { useSiteContent } from '../context/SiteContentContext';

const Logo = ({ className = "", size = "medium" }) => {
  const { content } = useSiteContent();
  
  const sizeClasses = {
    small: "h-10",
    medium: "h-14",
    large: "h-20"
  };

  return (
    <img
      src={content.logo_url}
      alt={`${content.company_name} ${content.slogan}`}
      className={`${sizeClasses[size]} w-auto object-contain ${className}`}
    />
  );
};

export default Logo;
